import { Factory } from 'fishery';
import { orderFactory } from '@trukt/factories/orderFactory';
import { accountFactory } from '@trukt/factories/accountFactory';
import { contactFactory } from '@trukt/factories/contactFactory';
import { commodityFactory } from '@trukt/factories/commodityFactory';
import { stopFactory } from '@trukt/factories/stopFactory';
import { OrderDetails, SearchOrderListItem, SearchOrderResponse } from './OrderServices.types';
import { userFactory } from '@trukt/factories/userFactory';

const orderResultFactory = Factory.define<SearchOrderListItem>(({ sequence }) => ({
  guid: sequence.toString(),
  number: 'LD16844',
  status: 'submitted',
  clientContactName: contactFactory.build().name,
  commodityIdentifier: commodityFactory.build().identifier,
  referenceNumber: '12345678',
  dateCreated: '2023-01-25T20:29:52.828-08:00',
  dateUpdated: '2023-11-13T11:00:03.944-08:00',
  commodityCount: 4,
  caseLabelCount: 0,
  commodityAllOperable: null,
  commodityAnyDamaged: null,
  caseLabels: [],
  client: accountFactory.build(),
  dispatcher: userFactory.build(),
  salesperson: userFactory.build(),
  financeStats: null,
  clientPayment: '0.00',
  originName: stopFactory.build().terminal.name,
  originAddress: '123 Main St',
  destination: stopFactory.build(),
  vehicleName: 'Vehicle 1',
  destinationName: stopFactory.build().terminal.name,
  destinationAddress: '456 Elm St',
  dateRequestedPickupEnd: '2023-01-25T20:29:52.828-08:00',
  dateRequestedPickupStart: '2023-01-25T20:29:52.828-08:00',
  dateScheduledPickupEnd: '2023-01-25T20:29:52.828-08:00',
  dateScheduledPickupStart: '2023-01-25T20:29:52.828-08:00',
  dateStarted: '2023-01-25T20:29:52.828-08:00',
  dateRequestedDeliveryEnd: '2023-01-25T20:29:52.828-08:00',
  dateRequestedDeliveryStart: '2023-01-25T20:29:52.828-08:00',
  dateScheduledDeliveryEnd: '2023-01-25T20:29:52.828-08:00',
  dateScheduledDeliveryStart: '2023-01-25T20:29:52.828-08:00',
  dateCompleted: '2023-01-25T20:29:52.828-08:00',
  pricing: '0.00',
}));

export const searchOrderResponseFactory = Factory.define<SearchOrderResponse>(() => ({
  results: orderResultFactory.buildList(25),
  page: 1,
  next: true,
  rows: 25,
  total: 100,
}));

export const getOrderResponseFactory = Factory.define<OrderDetails>(() => {
  const { ...rest } = orderFactory.build();
  return rest;
});
